import { config } from 'lib/config'

export enum CollectionCategory {
  category1 = 'category1',
  category2 = 'category2',
  category3 = 'category3',
  category4 = 'category4',
  category5 = 'category5',
  category6 = 'category6',
  category7 = 'category7',
  category8 = 'category8',
}

export const getCollectionCategoryUrlPath = (category: CollectionCategory | undefined): string => {
  return `${config.ROOT_PATH}images/collection-categories/${
    category || CollectionCategory.category1
  }.svg`
}

export const getCollectionCategoryValues = (): string[] => {
  return Object.values(CollectionCategory)
}
